import React from 'react';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useState } from 'react';
import { ReactSVG } from 'react-svg';
import { t } from '../../utilities/translator';
import { selectFilterData } from '../../features/mainFilter/selectors';
import { useRef } from 'react';
import { pushEvent } from '../../utilities/analytics';
import { RELOADPOPUP_SHOWN } from '../../constants/analyticEvents';
import { selectDealsList } from '../../features/dealsList/dealsListSlice';
import { getImage } from '../../utilities/iconResolver';
import { updateSecondaryFilterFromUrl } from '../../features/secondaryFilter/secondaryFilterSlice';
import { updateMainFilterFromUrl } from '../../features/mainFilter/mainFilterSlice';
import { scrollToResults } from '../../utilities/helpers';

const ReloadPopup = () => {
  const dispatch = useDispatch();
  const mainFilter = useSelector(selectFilterData);
  const { dealsList } = useSelector(selectDealsList);
  const { data: secondaryFilter } = useSelector((state) => state.secondaryFilter);

  const [showModal, setShowModal] = useState(false);
  const timer = useRef();

  const reloadPage = () => {
    setShowModal(false);
    dispatch(updateMainFilterFromUrl());
    dispatch(updateSecondaryFilterFromUrl());
    scrollToResults();
    // window.location.reload();
  };

  useEffect(
    () =>  {
      if (timer.current) {
        clearTimeout(timer.current);
      }

      timer.current = setTimeout(() => {
        if (dealsList.length < 1) return undefined;
        setShowModal(true);
        pushEvent(RELOADPOPUP_SHOWN);
        window.closeOneTapLoginModal();

      }, 60 * 60 * 1000);
    },
    [mainFilter, secondaryFilter, dealsList]
  );


  if (!showModal) {
    return null;
  }

  return (
    <div className="reload-popup-overlay">
      <div className="reload-popup">
        <div className="reload-popup-image-wrap">
          <ReactSVG src={getImage('offer-refresh-popup.svg')} />
        </div>
        <h3 className="reload-popup-title">{t('reloadPopup.please_refresh')}</h3>
        <div className="reload-popup-text">{t('reloadPopup.since_you_ve_been_on_this_page')}</div>
        <div className="hfep-btn-container">
          <button onClick={reloadPage} className="reload-popup-button">
            {t('reloadPopup.refresh_results')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReloadPopup;
